module.exports = __webpack_public_path__ + "static/media/203-Verlassen_ID_2.75eaf17b.mp3";